import { Controller } from "@hotwired/stimulus"

const OPEN_CLASS = 'open'

export default class extends Controller {
    static targets = ['sortField', 'sortDropdown', 'sortDropdownItem', 'selectedItem', 'sortInput', 'sortArrow']

    connect() {
        this.documentClickHandler = (e) => {
            if (!this.sortFieldTarget.contains(e.target)) {
                this.closeDropdown()
            }
        }
        window.addEventListener('click', this.documentClickHandler)
    }

    disconnect() {
        window.removeEventListener('click', this.documentClickHandler)
    }

    toggleDropdown() {
        const isOpen = this.sortDropdownTarget.classList.toggle(OPEN_CLASS)
        this.sortArrowTarget.classList.toggle(OPEN_CLASS, isOpen)
    }

    selectItem(event) {
        event.stopPropagation()
        const item = event.currentTarget
        this.selectedItemTarget.innerText = item.innerText
        this.sortInputTarget.value = item.dataset.value
        this.closeDropdown()
        console.log('selectItem', { value: this.sortInputTarget.value })

        this.dispatch('filter-applied', {detail: {name: 'sort', values: this.sortInputTarget.value}});
    }

    closeDropdown() {
        this.sortDropdownTarget.classList.remove(OPEN_CLASS)
        this.sortArrowTarget.classList.remove(OPEN_CLASS)
    }
}
